import { render, staticRenderFns } from "./TableWidget.vue?vue&type=template&id=89b5a672"
import script from "./TableWidget.vue?vue&type=script&lang=js"
export * from "./TableWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports